import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon, IconButton, Button } from '@adsk/bim360-matrix-react-components';

const FilterIndicator = ({ clearFilters, text, onClick }) => {

  const handleClearFilters = (e) => {
    e.stopPropagation();
    clearFilters();
  };
  return (
    <Button className="FilterIndicator" styleType={Button.StyleType.INLINE_LINK} onClick={onClick} >
      <span className="FilterIndicator__text">{text}</span>
      <IconButton onClick={handleClearFilters} className="FilterIndicator__clear-filters">
        <SvgIcon height="14px" width="14px" svgId="close-rounded-icon" />
      </IconButton>
    </Button>
  );
};

FilterIndicator.displayName = 'FilterIndicator';

FilterIndicator.propTypes = {
  text: PropTypes.string.isRequired,
  clearFilters: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default FilterIndicator;
